/*
 * ॐ नमः शिवाय
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 *
 * You are free to use, modify, and distribute this software under the terms
 * of the VIJAYA 1.0 License.
 *
 * MANDATORY ATTRIBUTION:
 * 1. The attribution to Rudra Coresoft Technologies Private Limited in this
 *    copyright notice must not be removed even after modifications.
 * 2. For Free License usage, the footer phrases "Powered by arcee.io" and
 *    "Developed by Rudra Coresoft" (plus logos) must remain visible.
 *
 * See the LICENSE file for the full text.
 */

import React, { useState } from "react";
import { createPortal } from "react-dom";

/**
 * JsonCell — a compact "{...}" chip that reveals the full, pretty-printed JSON
 * in a dark, scrollable tooltip on hover. Rendered through a portal so a table's
 * overflow does not clip it. Used in table/list cells for json/jsonb fields.
 */
export default function JsonCell({ value }) {
  const [pos, setPos] = useState(null); // { left, top } in viewport coords, or null
  const fullStr = typeof value === "string" ? value : JSON.stringify(value, null, 2);

  const show = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    setPos({ left: r.left, top: r.bottom + 6 });
  };

  return (
    <>
      <span
        onMouseEnter={show}
        onMouseLeave={() => setPos(null)}
        style={{
          display: "inline-block",
          background: "#f1f5f9",
          border: "1px solid #cbd5e1",
          borderRadius: 6,
          padding: "2px 8px",
          fontSize: "0.82rem",
          fontFamily: "monospace",
          cursor: "pointer",
        }}
      >
        {"{...}"}
      </span>
      {pos && createPortal(
        <pre
          style={{
            position: "fixed",
            left: pos.left,
            top: pos.top,
            zIndex: 9999,
            margin: 0,
            maxWidth: 460,
            maxHeight: 320,
            overflow: "auto",
            background: "#1e293b",
            color: "#e2e8f0",
            padding: "10px 14px",
            borderRadius: 8,
            fontFamily: "monospace",
            fontSize: "0.8rem",
            lineHeight: 1.5,
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            boxShadow: "0 8px 28px rgba(0,0,0,0.35)",
            pointerEvents: "none",
          }}
        >
          {fullStr}
        </pre>,
        document.body
      )}
    </>
  );
}
